import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.digital_twin.kinematics');
import { OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

declare let wiz: any;

const PROJECT_WORKFLOW_ID_KEY = 'actuator:lastProjectId';

@Component({
    standalone: false,
    selector: 'wiz-page-digital_twin-kinematics',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.digital_twin.kinematics/view.scss */
:host {
  display: block;
  height: 100%;
}

.twin-shell {
  background: linear-gradient(135deg, var(--twin-bg-start), var(--twin-bg-mid), var(--twin-bg-end));
  color: var(--twin-text);
  transition: background-color 180ms ease, color 180ms ease;
  --twin-bg-start: #f8fafc;
  --twin-bg-mid: #ffffff;
  --twin-bg-end: #e2e8f0;
  --twin-text: #0f172a;
  --twin-muted: #64748b;
  --twin-border: rgba(148, 163, 184, 0.36);
  --twin-card: rgba(255, 255, 255, 0.88);
}

:host-context(.dark) .twin-shell,
.twin-dark {
  --twin-bg-start: #020617;
  --twin-bg-mid: #0f172a;
  --twin-bg-end: #18181b;
  --twin-text: #f8fafc;
  --twin-muted: #94a3b8;
  --twin-border: rgba(255, 255, 255, 0.1);
  --twin-card: rgba(15, 23, 42, 0.62);
}

.twin-light [class*="border-white/"] {
  border-color: var(--twin-border) !important;
}

.twin-light [class*=bg-slate-950],
.twin-light [class*="bg-white/5"] {
  background-color: var(--twin-card) !important;
}

.twin-light .text-white,
.twin-light .text-slate-100,
.twin-light .text-slate-200 {
  color: var(--twin-text) !important;
}

.twin-light .text-slate-300,
.twin-light .text-slate-400,
.twin-light .text-slate-500 {
  color: var(--twin-muted) !important;
}

.twin-light .text-violet-400 {
  color: #7c3aed !important;
}

.kinematics-project-button {
  border-color: rgba(8, 145, 178, 0.55) !important;
  background-color: #0891b2 !important;
  color: #ffffff !important;
  box-shadow: 0 8px 18px rgba(8, 145, 178, 0.18);
}

.kinematics-project-button:hover {
  background-color: #0e7490 !important;
  color: #ffffff !important;
}

.kinematics-stage {
  min-height: clamp(560px, 100vh - 220px, 920px);
}

.kinematics-canvas-wrap {
  min-height: 520px;
}

canvas {
  touch-action: none;
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

@media (max-width: 768px) {
  .kinematics-stage {
    min-height: clamp(420px, 100vh - 190px, 680px);
  }
  .kinematics-canvas-wrap {
    min-height: 400px;
  }
}`],
})
export class PageDigital_twinKinematicsComponent implements OnInit, OnDestroy {
    constructor(@Inject( Service) public service: Service) {}

    public theme: 'light' | 'dark' = 'light';
    public projectId: string = '';
    private get isDark(): boolean { return this.theme === 'dark'; }

    @ViewChild('kinematicCanvas3D') canvasRef?: ElementRef;
    private _animFrame: number = 0;
    private _animRunning = false;
    private _animPos: number = 0;
    private _animDir: number = 1;
    private _kRotX: number = -0.38;
    private _kRotY: number = 0.55;
    private _kDrag = false;
    private _kPrev = { x: 0, y: 0 };
    public loadRatio: number = 50;
    public kParams: any = {
        targetAngle: 80, partType: '트렁크',
        hingePos: [0, 0, 0], cogLocal: [0.15, 0, -0.02], mountLocal: [0.05, 0.12, -0.03],
    };

    public async ngOnInit() {
        await this.service.init();
        this.projectId = this.routeProjectId();
        this.rememberProjectId(this.projectId);
        this.syncGlobalTheme();
        await this.loadSimulationParams(this.projectId);
        setTimeout(() => this.initKinematicCanvas(), 80);
        await this.service.render();
    }

    ngOnDestroy() {
        this._animRunning = false;
        if (this._animFrame) { cancelAnimationFrame(this._animFrame); this._animFrame = 0; }
    }

    private syncGlobalTheme() {
        try {
            const saved = localStorage.getItem('appTheme');
            this.theme = saved === 'dark' ? 'dark' : 'light';
        } catch (e) { this.theme = 'light'; }
    }

    private routeProjectId(): string {
        const params = new URLSearchParams(location.search);
        const queryId = params.get('project_id') || '';
        if (queryId) return queryId;
        try {
            return localStorage.getItem(PROJECT_WORKFLOW_ID_KEY) || '';
        } catch (e) {
            return '';
        }
    }

    private rememberProjectId(id: string) {
        if (!id) return;
        try {
            localStorage.setItem(PROJECT_WORKFLOW_ID_KEY, id);
        } catch (e) {}
    }

    public digitalTwinToolUrl(path: string): string {
        return this.projectId ? `${path}?project_id=${encodeURIComponent(this.projectId)}` : path;
    }

    public projectDigitalTwinUrl(): string {
        return this.projectId ? `/projects/${encodeURIComponent(this.projectId)}/digital_twin` : '/projects';
    }

    public goDigitalTwinTool(path: string) {
        this.service.href(this.digitalTwinToolUrl(path));
    }

    public goProjectDigitalTwin() {
        this.service.href(this.projectDigitalTwinUrl());
    }

    private async loadSimulationParams(projectId: string = '') {
        const { code, data } = await wiz.call("simulation_params", { project_id: projectId });
        if (code === 200) {
            this.kParams.targetAngle = data.targetAngle ?? 80;
            this.kParams.partType = data.partType ?? '트렁크';
            this.kParams.hingePos = [data.hingeX ?? 0, data.hingeY ?? 0, data.hingeZ ?? 0];
            this.kParams.cogLocal = [
                (data.cogX ?? 0.15) - (data.hingeX ?? 0),
                (data.cogY ?? 0) - (data.hingeY ?? 0),
                (data.cogZ ?? -0.02) - (data.hingeZ ?? 0),
            ];
            this.kParams.mountLocal = [
                (data.mountX ?? 0.05) - (data.hingeX ?? 0),
                (data.mountY ?? 0.12) - (data.hingeY ?? 0),
                (data.mountZ ?? -0.03) - (data.hingeZ ?? 0),
            ];
        }
    }

    public resetKinematicView() {
        this._kRotX = -0.38; this._kRotY = 0.55;
    }

    // ── 3D Canvas ──────────────────────────────────────────────────────────
    private initKinematicCanvas() {
        const el = this.canvasRef?.nativeElement as HTMLCanvasElement | undefined;
        if (!el) { setTimeout(() => this.initKinematicCanvas(), 200); return; }
        el.style.cursor = 'grab';
        el.addEventListener('mousedown', (e: MouseEvent) => {
            this._kDrag = true; this._kPrev = { x: e.clientX, y: e.clientY };
            el.style.cursor = 'grabbing';
        });
        el.addEventListener('mousemove', (e: MouseEvent) => {
            if (!this._kDrag) return;
            this._kRotY += (e.clientX - this._kPrev.x) * 0.007;
            this._kRotX -= (e.clientY - this._kPrev.y) * 0.007;
            this._kRotX = Math.max(-Math.PI * 0.42, Math.min(Math.PI * 0.42, this._kRotX));
            this._kPrev = { x: e.clientX, y: e.clientY };
        });
        el.addEventListener('mouseup', () => { this._kDrag = false; el.style.cursor = 'grab'; });
        el.addEventListener('mouseleave', () => { this._kDrag = false; el.style.cursor = 'grab'; });
        el.addEventListener('touchstart', (e: TouchEvent) => {
            this._kDrag = true; this._kPrev = { x: e.touches[0].clientX, y: e.touches[0].clientY };
            e.preventDefault();
        }, { passive: false });
        el.addEventListener('touchmove', (e: TouchEvent) => {
            if (!this._kDrag) return;
            this._kRotY += (e.touches[0].clientX - this._kPrev.x) * 0.007;
            this._kRotX -= (e.touches[0].clientY - this._kPrev.y) * 0.007;
            this._kRotX = Math.max(-Math.PI * 0.42, Math.min(Math.PI * 0.42, this._kRotX));
            this._kPrev = { x: e.touches[0].clientX, y: e.touches[0].clientY };
            e.preventDefault();
        }, { passive: false });
        el.addEventListener('touchend', () => { this._kDrag = false; });
        this._animRunning = true;
        this.kAnimLoop(el);
    }

    private kProject(x: number, y: number, z: number, W: number, H: number): { px: number, py: number } {
        const cy = Math.cos(this._kRotY), sy = Math.sin(this._kRotY);
        const x2 = x * cy + z * sy, z2 = -x * sy + z * cy;
        const cx = Math.cos(this._kRotX), sx = Math.sin(this._kRotX);
        const y2 = y * cx - z2 * sx, z3 = y * sx + z2 * cx;
        const SCALE = Math.max(260, Math.min(W, H) * 0.46);
        const fov = 4.5, d = fov / (fov + z3 * 0.3 + 0.1);
        return { px: W / 2 + x2 * d * SCALE, py: H / 2 + 20 - y2 * d * SCALE };
    }

    private kAnimLoop(el: HTMLCanvasElement) {
        if (!this._animRunning) return;
        const viewport = this.resizeCanvas(el);
        const ctx = el.getContext('2d');
        if (ctx) {
            ctx.setTransform(viewport.dpr, 0, 0, viewport.dpr, 0, 0);
            this.kDraw(ctx, viewport.width, viewport.height);
        }
        const SPEED = 0.18;
        this._animPos += SPEED * this._animDir;
        if (this._animPos >= 100) { this._animPos = 100; this._animDir = -1; }
        else if (this._animPos <= 0) { this._animPos = 0; this._animDir = 1; }
        this._animFrame = requestAnimationFrame(() => this.kAnimLoop(el));
    }

    private resizeCanvas(el: HTMLCanvasElement): { width: number; height: number; dpr: number } {
        const rect = el.getBoundingClientRect();
        const dpr = Math.min(window.devicePixelRatio || 1, 2);
        const cssWidth = Math.max(320, Math.floor(rect.width || 800));
        const cssHeight = Math.max(360, Math.floor(rect.height || 400));
        const backingWidth = Math.floor(cssWidth * dpr);
        const backingHeight = Math.floor(cssHeight * dpr);
        if (el.width !== backingWidth || el.height !== backingHeight) {
            el.width = backingWidth;
            el.height = backingHeight;
        }
        return { width: cssWidth, height: cssHeight, dpr };
    }

    private kDraw(ctx: CanvasRenderingContext2D, W: number, H: number) {
        ctx.clearRect(0, 0, W, H);
        const dark = this.isDark;
        const pos = this._animPos;
        const angle = (pos / 100) * (this.kParams.targetAngle * Math.PI / 180);
        const Hv = this.kParams.hingePos as number[];

        const ry = (p: number[], a: number) => {
            const c = Math.cos(a), s = Math.sin(a);
            return [p[0] * c + p[2] * s, p[1], -p[0] * s + p[2] * c];
        };
        const trf = (lp: number[]) => {
            const r = ry(lp, angle);
            return [r[0] + Hv[0], r[1] + Hv[1], r[2] + Hv[2]];
        };
        const P = (x: number, y: number, z: number) => this.kProject(x, y, z, W, H);
        const line = (a: number[], b: number[], color: string, w = 1.5) => {
            const pa = P(a[0], a[1], a[2]), pb = P(b[0], b[1], b[2]);
            ctx.beginPath(); ctx.strokeStyle = color; ctx.lineWidth = w;
            ctx.moveTo(pa.px, pa.py); ctx.lineTo(pb.px, pb.py); ctx.stroke();
        };
        const poly = (pts: number[][], fill: string, stroke?: string, sw = 0.8) => {
            const pr = pts.map(p => P(p[0], p[1], p[2]));
            ctx.beginPath(); ctx.moveTo(pr[0].px, pr[0].py);
            for (let i = 1; i < pr.length; i++) ctx.lineTo(pr[i].px, pr[i].py);
            ctx.closePath();
            if (fill) { ctx.fillStyle = fill; ctx.fill(); }
            if (stroke) { ctx.strokeStyle = stroke; ctx.lineWidth = sw; ctx.stroke(); }
        };
        const dot = (p: number[], color: string, r = 4.5, label?: string) => {
            const pt = P(p[0], p[1], p[2]);
            ctx.beginPath(); ctx.fillStyle = color;
            ctx.arc(pt.px, pt.py, r, 0, Math.PI * 2); ctx.fill();
            if (label) {
                ctx.font = '9px Inter,system-ui,sans-serif';
                ctx.fillStyle = dark ? 'rgba(203,213,225,0.85)' : 'rgba(30,41,59,0.85)';
                ctx.fillText(label, pt.px + r + 2, pt.py + 3);
            }
        };

        // Grid
        ctx.strokeStyle = dark ? 'rgba(255,255,255,0.035)' : 'rgba(0,0,0,0.05)';
        ctx.lineWidth = 0.5;
        for (let gx = -1.0; gx <= 1.0; gx += 0.25) {
            const a = P(gx, -0.26, -1.0), b = P(gx, -0.26, 1.0);
            ctx.beginPath(); ctx.moveTo(a.px, a.py); ctx.lineTo(b.px, b.py); ctx.stroke();
        }
        for (let gz = -1.0; gz <= 1.0; gz += 0.25) {
            const a = P(-1.0, -0.26, gz), b = P(1.0, -0.26, gz);
            ctx.beginPath(); ctx.moveTo(a.px, a.py); ctx.lineTo(b.px, b.py); ctx.stroke();
        }

        // Car body
        const bf = dark ? 'rgba(30,41,59,0.65)' : 'rgba(226,232,240,0.70)';
        const be = dark ? 'rgba(100,116,139,0.6)' : 'rgba(100,116,139,0.6)';
        const bx1 = -0.65, bx2 = 0.65, by1 = -0.25, by2 = 0, bz1 = -0.55, bz2 = 0.55;
        poly([[bx1,by1,bz1],[bx2,by1,bz1],[bx2,by2,bz1],[bx1,by2,bz1]], bf, be);
        poly([[bx1,by1,bz2],[bx2,by1,bz2],[bx2,by2,bz2],[bx1,by2,bz2]], bf, be);
        poly([[bx1,by1,bz1],[bx1,by1,bz2],[bx1,by2,bz2],[bx1,by2,bz1]], bf, be);
        poly([[bx2,by1,bz1],[bx2,by1,bz2],[bx2,by2,bz2],[bx2,by2,bz1]], bf, be);
        poly([[bx1,by2,bz1],[bx2,by2,bz1],[bx2,by2,bz2],[bx1,by2,bz2]], bf, be);

        // Door/Trunk panel
        const pw = 0.6, pl = 0.58, pt = 0.022;
        const rawPts = [
            [-pw/2,0,0],[pw/2,0,0],[pw/2,0,pl],[-pw/2,0,pl],
            [-pw/2,pt,0],[pw/2,pt,0],[pw/2,pt,pl],[-pw/2,pt,pl]
        ];
        const ptsW = rawPts.map(p => trf(p));
        const lr = this.loadRatio;
        const pFill = dark ? 'rgba(34,211,238,0.28)' : 'rgba(14,165,233,0.18)';
        const pEdge = '#22d3ee';
        poly([ptsW[0],ptsW[1],ptsW[2],ptsW[3]], pFill, pEdge, 1.2);
        poly([ptsW[4],ptsW[5],ptsW[6],ptsW[7]], pFill, pEdge, 1.2);
        [[0,1],[1,2],[2,3],[3,0],[4,5],[5,6],[6,7],[7,4],[0,4],[1,5],[2,6],[3,7]].forEach(([a,b]) =>
            line(ptsW[a], ptsW[b], pEdge, 1.0));

        // Hinge axis
        line([Hv[0]-pw/2,Hv[1],Hv[2]], [Hv[0]+pw/2,Hv[1],Hv[2]],
            dark ? 'rgba(251,191,36,0.55)' : 'rgba(217,119,6,0.55)', 1.2);

        // Actuator rod
        const cogW = trf(this.kParams.cogLocal);
        const mountDoorW = trf(this.kParams.mountLocal);
        const mountBodyP = [0.2, -0.05, bz1 * 0.4];
        const aLen = Math.sqrt(
            (mountDoorW[0]-mountBodyP[0])**2 +
            (mountDoorW[1]-mountBodyP[1])**2 +
            (mountDoorW[2]-mountBodyP[2])**2
        );
        const aC = '#22d3ee';
        line(mountBodyP, mountDoorW, dark ? 'rgba(0,0,0,0.3)' : 'rgba(0,0,0,0.12)', 4.5);
        line(mountBodyP, mountDoorW, aC, 2.8);

        // Key points
        dot(Hv, '#f59e0b', 5, 'Hinge');
        dot(cogW, '#a78bfa', 4, 'COG');
        dot(mountBodyP, '#4ade80', 4, 'Body Mt.');
        dot(mountDoorW, aC, 4, 'Door Mt.');

        // XYZ Axes
        line([0,0,0],[0.22,0,0],'#ef4444',1.2); dot([0.22,0,0],'#ef4444',2.5,'X');
        line([0,0,0],[0,0.22,0],'#22c55e',1.2); dot([0,0.22,0],'#22c55e',2.5,'Y');
        line([0,0,0],[0,0,0.22],'#3b82f6',1.2); dot([0,0,0.22],'#3b82f6',2.5,'Z');

        // Info overlay
        const tc = dark ? 'rgba(203,213,225,0.88)' : 'rgba(30,41,59,0.88)';
        const sc = dark ? 'rgba(148,163,184,0.7)' : 'rgba(71,85,105,0.7)';
        const openDeg = (pos / 100 * this.kParams.targetAngle).toFixed(1);
        ctx.font = 'bold 11px Inter,system-ui,sans-serif';
        ctx.fillStyle = tc;
        ctx.fillText(`${this.kParams.partType}  ${openDeg}° / ${this.kParams.targetAngle}°`, 10, 18);
        ctx.font = '10px Inter,system-ui,sans-serif';
        ctx.fillStyle = sc;
        ctx.fillText(`Actuator: ${aLen.toFixed(3)} m`, 10, 32);
        ctx.fillStyle = dark ? 'rgba(100,116,139,0.55)' : 'rgba(148,163,184,0.75)';
        ctx.fillText('드래그하여 뷰 회전', 10, H - 10);
    }
}

export default PageDigital_twinKinematicsComponent;